import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchWorkspaceBranding } from '@/api/branding/brandingApi';
import type { Branding } from '@/api/branding/brandingApi.types';
import { WORKSPACE_BRANDING_QUERY_KEY } from '@/constants/queryKeys';

export function useWorkspaceBrandingQuery(
  isEnabled: boolean
): UseQueryResult<Branding, Error> {
  return useQuery({
    queryKey: WORKSPACE_BRANDING_QUERY_KEY,
    queryFn: fetchWorkspaceBranding,
    enabled: isEnabled,
  });
}
